import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function GenderEmp() {
  return (
    <SettingsMetaData propertyName={"Gender_emp"} viewPropertyName={"Gender"} />
)
}

export default GenderEmp